import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { Box } from '@mui/system';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import CtaWithRightButtons from '../../../../components/cta/CtaWithRightButtons';
import DialogCancelarEnvio from '../../envios/DialogCancelarEnvio';
import DialogCancelarEnvioUser from '../../envios/DialogCancelarEnvioUser';
import { fDateN } from '../../../../../utils/formatTime';
import DialogMensajeLimiteCancelar from './DialogMensajeLimiteCancelar';
import useUserRole from '../../../../../hooks/useUserRole';
import { useLocation } from 'react-router';

const ahora = new Date();
const hace24Horas = new Date(ahora.getTime() - 24 * 60 * 60 * 1000);

export default function DialogSolCancelarEnv({ data }) {
  const [openDialog, setOpenDialog] = useState(false);
  const { actualRol, admitByUserType, admitByRoleName } = useUserRole();
  const { pathname } = useLocation();

  const fechaCreacion = data.created_at.toDate();

  const sePuedeCancelar = fechaCreacion >= hace24Horas;

  const isAdminPath = pathname.includes('administracion');

  console.log({ sePuedeCancelar });

  return (
    <>
      {!isAdminPath && (
        <>
          {!sePuedeCancelar && (
            <>
              <DialogMensajeLimiteCancelar data={data} />
            </>
          )}
          {sePuedeCancelar && (
            <>
              <Button variant="contained" color="error" onClick={() => setOpenDialog(true)}>
                Solicitar cancelacion
              </Button>
              <CancelDialog open={openDialog} onClose={setOpenDialog} data={data} />
            </>
          )}
        </>
      )}

      {isAdminPath && (
        <>
          <Button variant="contained" color="error" onClick={() => setOpenDialog(true)}>
            Solicitar cancelacion
          </Button>
          <CancelDialog open={openDialog} onClose={setOpenDialog} data={data} />
        </>
      )}
    </>
  );
}

function CancelDialog({ open, onClose, data }) {
  const { state, status } = data;

  const handleClose = () => {
    onClose(false);
  };

  const dialogProp = {
    color: 'primary',
    size: 'large'
  };
  let component;
  let conditionalText;

  if (state === 'PAGADO') {
    component = <DialogCancelarEnvioUser dialogProp={dialogProp} data={data} />;
    conditionalText = 'Solicitar la cancelacion de este envio.';
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {/* <DialogTitle id="alert-dialog-title">Titulo del dialogo</DialogTitle> */}
      <DialogContent>
        <Box
          sx={{
            width: '100%',
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '20px'
          }}
        >
          <CtaWithRightButtons
            title="Cancelar envio"
            contentText="Cancele los envios y guias generadas desde aquí."
            conditionalText={conditionalText}
            btnAction={component}
            showAdvert
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit" startIcon={<KeyboardBackspaceIcon />}>
          Atras
        </Button>
      </DialogActions>
    </Dialog>
  );
}
